module.exports = [{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Vinylbase ❤️ Gatsby + GraphQL + GraphCMS","short_name":"Vinylbase","start_url":"/","background_color":"#fff","theme_color":"#61045f","display":"standalone","icons":[{"src":"/favicons/chrome-192.png","sizes":"192x192","type":"image/png"},{"src":"/favicons/chrome-512.png","sizes":"512x512","type":"image/png"}]},
    },{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
